import { Component, Input } from "@angular/core";

@Component({
	selector: 'app-table-loading-overlay',
	templateUrl: './table-loading-overlay.component.html',
	styleUrls: ['./table-loading-overlay.component.scss']
})
export class TableLoadingOverlayComponent {
	@Input() isLoading: boolean = false;
}